import React, { useState, useEffect } from 'react'
import { Form, Container } from 'react-bootstrap';
import { Button } from '../components/ButtonElement';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import firebase from 'firebase';
import { MdDelete } from 'react-icons/md';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const NavLogo = styled(Link)`
 color: #fff;
 display:flex;
 justify-self:flex-start;
 align-items:center;
 margin-left:24px;
 font-weight:bold;
 text-decoration:none;
 cursor: pointer;
 &:hover{
     text-decoration:none;
     color:#fff;
 }
`
const Gratitude = (props) => {
    const { currentUser } = useAuth();
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
            <li key={props.gratitude.id}>{props.gratitude.gratitude}</li>{/*{props.gratitude.date.substring(0, 15)} */}
            <MdDelete style={{ cursor: 'pointer', marginLeft: '20px' }} onClick={event => db.collection('users').doc(currentUser.uid).collection('gratitude').doc(props.gratitude.id).delete()}>Delete</MdDelete>
        </div >
    );
}

const GratitudeDiary = () => {
    const [gratitudes, setGratitudes] = useState([])
    const [input, setInput] = useState("I'm grateful for ");
    const { currentUser } = useAuth();

    const addGratitude = (event) => {
        event.preventDefault();
        db.collection('users').doc(currentUser.uid).collection('gratitude').add({
            gratitude: input,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
        setInput("I'm grateful for ");
    }

    useEffect(() => {
        db.collection('users').doc(currentUser.uid).collection('gratitude').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
            setGratitudes(snapshot.docs.map(doc => ({ id: doc.id, gratitude: doc.data().gratitude })))
        });
    }, [currentUser]);

    return (
        <Container style={{ minHeight: "100vh", minWidth: "100vw", backgroundColor: '#01bf71', overflowY: 'hidden' }}>
            <NavLogo to="/" style={{ position: "absolute", marginTop: '20px' }}> MindSpace <span style={{ fontStyle: "italic", fontSize: '14px' }}>  Gratitude Diary</span></NavLogo>
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ marginBottom: '20px' }}> Save what you are grateful for!</div>
                <Form action="" style={{ display: 'flex', flexDirection: 'row', marginBottom: '20px' }}>
                    <input value={input} onChange={event => setInput(event.target.value)} />
                    <Button disabled={!input} type="submit" onClick={addGratitude}>Add</Button>
                </Form>
                <ul>
                    {gratitudes.map(gratitude => (
                        <Gratitude gratitude={gratitude} />
                    ))}
                </ul>
            </div>
        </Container>
    )
}
export default GratitudeDiary;
